import React, { useState, useCallback } from "react";
import { styles } from "../../styles/request_details";
import "../../styles/request_dashboard.scss";

interface SystemAdminApprovalProps {
    isProcessing: boolean;
    onReject: () => void;
    onOpenAssignModal: () => void;
    stage?: any;
}
const SystemAdminApproval: React.FC<SystemAdminApprovalProps> = ({
    isProcessing,
    onReject,
    onOpenAssignModal,
    stage,
}) => {
    const [isRejectHovered, setIsRejectHovered] = useState(false);
    const [isAssignHovered, setIsAssignHovered] = useState(false);

    const handleRejectMouseEnter = useCallback(() => {
        if (!isProcessing) setIsRejectHovered(true);
    }, [isProcessing]);

    const handleRejectMouseLeave = useCallback(() => setIsRejectHovered(false), []);

    const handleAssignMouseEnter = useCallback(() => {
        if (!isProcessing) setIsAssignHovered(true);
    }, [isProcessing]);

    const handleAssignMouseLeave = useCallback(() => setIsAssignHovered(false), []);

    const rejectButtonStyle = {
        ...styles.rejectButton,
        ...(isProcessing && styles.buttonDisabled),
        ...(isRejectHovered && !isProcessing && { textDecoration: "underline" }),
    };

    const assignButtonStyle = {
        ...styles.approveButton,
        ...(isProcessing && styles.buttonDisabled),
        ...(isAssignHovered && !isProcessing && { backgroundColor: "#D4A610" }),
    };
    const hasChainInfo = !!stage?.chainId;
    return (
        <div className="saa-section">
            <div className="saa-content">
                <h3 style={styles.rejectHeading}>Request is in Open status</h3>
                <p style={styles.rejectText}>
                    Review the user details and requested access. Select the chain and store
                    scope to enable sending this request to Internal Project Admin for approval.
                </p>
            </div>
            <div className="saa-btn-group">
                {!hasChainInfo && (
                    <button
                        style={rejectButtonStyle}
                        onClick={onReject}
                        disabled={isProcessing}
                        onMouseEnter={handleRejectMouseEnter}
                        onMouseLeave={handleRejectMouseLeave}
                        aria-label="Reject request"
                    >
                        Reject
                    </button>
                )}
                <button
                    style={assignButtonStyle}
                    onClick={onOpenAssignModal}
                    disabled={isProcessing}
                    onMouseEnter={handleAssignMouseEnter}
                    onMouseLeave={handleAssignMouseLeave}
                    aria-label="Select Chain and Store"
                >
                    Select Chain and Store
                </button>
            </div>
        </div>
    );
};

export default SystemAdminApproval;